import React, {Component} from "react";
import PropTypes from "prop-types";
import {_appUpdateAvailable} from "../../../../../services/apis/AppServices";

class AppManager extends Component {
    componentDidMount() {
        _appUpdateAvailable()
            .then(result => {
                console.log(result);
            });
    }

    render() {
        return (
            <div className="AppManager">

            </div>
        );
    }
}

AppManager.propTypes = {
    history: PropTypes.object,
};

export default AppManager;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/app/AppManager/AppManager.js